import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b770fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "infographic-imgs"
}
const _hoisted_2 = { class: "infographic-imgs__item" }
const _hoisted_3 = { class: "infographic-imgs__item-img" }
const _hoisted_4 = { class: "infographic-imgs__item-text" }
const _hoisted_5 = {
  key: 1,
  class: "infographic-imgs-grey"
}
const _hoisted_6 = { class: "infographic-imgs-grey__container-title" }

import { computed, toRaw } from 'vue';
import { useAppStore } from '@/store/modules/app';

type InfographicImgsType = {
  title: string;
  icon: string | undefined;
}[];


export default /*#__PURE__*/_defineComponent({
  __name: 'InfographicImgs',
  props: {
    infographics: {},
    isGreen: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const preparedInfographicImgs = computed((): InfographicImgsType => {
  return infographicImgs.value.slice(0, 10);
});

const infographicImgs = computed((): InfographicImgsType => {
  const infographicData: InfographicImgsType = [];

  Object.entries(props.infographics).forEach(el => {
    const value = toRaw(el[1].value);

    const iconData = useAppStore().infographic_icons[el[0]];

    const addInfographicData = (value: number | number[] | string) => {
      const foundIconData = iconData.icons.find(el => {
        if (Array.isArray(value) && el.value) {
          return value.includes(+el.value);
        }
        if (!el.value && el.value !== null && !el.min_value && !el.max_value) {
          return !!value;
        }
        if (el.min_value || el.max_value) {
          if (el.min_value && !el.max_value) {
            return value >= el.min_value;
          }
          if (el.max_value && !el.min_value) {
            return value <= el.max_value;
          }
          if (el.min_value && el.max_value) {
            return value >= el.min_value && value <= el.max_value;
          }
        }

        return value === el.value;
      });

      if (foundIconData) {
        infographicData.push({
          title: foundIconData.title || iconData.name,
          icon: props.isGreen ? foundIconData.path : foundIconData.alternative_path,
        });
      }
    };

    if (iconData && value) {
      if (Array.isArray(value) && value.length > 1) {
        value.forEach(el => {
          addInfographicData(String(el));
        });
      } else {
        addInfographicData(value);
      }
    }
  });

  return infographicData;
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_divider = _resolveComponent("base-divider")!

  return (_ctx.isGreen && preparedInfographicImgs.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infographicImgs.value, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_image, {
                name: item.title,
                src: item.icon,
                contain: "",
                height: "28",
                width: "100%"
              }, null, 8, ["name", "src"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1)
            ])
          ]))
        }), 256))
      ]))
    : (preparedInfographicImgs.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass([{
        more8: preparedInfographicImgs.value.length > 8,
        more6: preparedInfographicImgs.value.length > 6,
        more5: preparedInfographicImgs.value.length > 5,
        more4: preparedInfographicImgs.value.length > 4,
        more2: preparedInfographicImgs.value.length > 2,
      }, "infographic-imgs-grey__container"])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedInfographicImgs.value, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                style: _normalizeStyle({ gridArea: `infoItem${i + 1}` }),
                class: "infographic-imgs-grey__container-item"
              }, [
                _createVNode(_component_base_image, {
                  name: item.title,
                  src: item.icon,
                  contain: "",
                  height: "25",
                  width: "30"
                }, null, 8, ["name", "src"]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
              ], 4))
            }), 128)),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createVNode(_component_base_divider, {
                class: _normalizeClass(`infographic-imgs-grey__container-divider${i}`)
              }, null, 8, ["class"])
            }), 64))
          ], 2)
        ]))
      : _createCommentVNode("", true)
}
}

})